<template>
  <basic-page title="Muonitus">
    <v-row class="fill-height">
      <v-col cols="12" lg="8" xl="8" offset-xl="2" offset-lg="2">
        <v-row>
          <v-col>
            <v-btn text to="/muonitus/pohjat">Hallitse kauppalistapohjia</v-btn>
            <v-btn text to="/muonitus/asetukset">Asetukset</v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-card>
              <v-card-title>
                Muonitustapahtumat
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Hae"
                  single-line
                  hide-details
                  class="mr-4"
                  :class="{
                    'expanded-search': searchExpanded,
                    'collapsed-search':
                      !searchExpanded && $vuetify.breakpoint.xs,
                  }"
                  @focus="searchExpanded = true"
                  @blur="onSearchBlur"
                ></v-text-field>
                <v-btn color="primary" rounded small @click="createNewEvent">
                  <v-icon>mdi mdi-plus</v-icon> Uusi muonitus
                </v-btn>
              </v-card-title>
              <v-divider></v-divider>
              <v-data-table
                :headers="headers"
                :items="events"
                :search="search"
                @click:row="openEvent"
                class="elevation-0"
                style="cursor: pointer"
              >
                <template v-slot:item.date="{ item }">
                  {{ formatDate(item.date) }}
                </template>
                <template v-slot:item.status="{ item }">
                  <v-chip :color="getStatusColor(item.status)" dark small>{{
                    getStatusText(item.status)
                  }}</v-chip>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </basic-page>
</template>

<script>
import { firestore as db } from "@/plugins/firebase.app";
import {
  collection,
  query,
  orderBy,
  onSnapshot,
  addDoc,
  Timestamp,
} from "firebase/firestore";
import dayjs from "dayjs";
import BasicPage from "@/components/BasicPage.vue";

export default {
  name: "Muonitus",
  components: { BasicPage },
  data() {
    return {
      events: [],
      search: "",
      searchExpanded: false,
      headers: [
        { text: "Pvm", value: "date" },
        { text: "Kuvaus", value: "description" },
        { text: "Tila", value: "status" },
        { text: "Hlö-arvio", value: "headCountEstimate" },
      ],
      unsubscribe: null,
    };
  },
  created() {
    const q = query(collection(db, "caterings"), orderBy("date", "desc"));
    this.unsubscribe = onSnapshot(q, (snapshot) => {
      this.events = snapshot.docs
        .map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }))
        .filter((event) => !event.deletedAt);
    });
  },
  beforeDestroy() {
    if (this.unsubscribe) this.unsubscribe();
  },
  methods: {
    formatDate(timestamp) {
      if (!timestamp) return "";
      return dayjs(timestamp.toDate()).format("DD.MM.YYYY HH:mm");
    },
    getStatusColor(status) {
      const colors = {
        planned: "grey",
        shopping: "orange",
        delivered: "light-blue",
        done: "green",
        billed: "blue",
      };
      return colors[status] || "grey";
    },
    getStatusText(status) {
      const texts = {
        planned: "Suunnitteilla",
        shopping: "Ostoksilla / Valmistuksessa",
        delivered: "Toimitettu maastoon",
        done: "Valmis / Purettu",
        billed: "Laskutettu",
      };
      return texts[status] || status;
    },
    async createNewEvent() {
      try {
        const newEvent = {
          date: Timestamp.now(),
          description: "Uusi muonitus",
          headCountEstimate: 0,
          status: "planned",
          shoppingList: [],
        };
        const docRef = await addDoc(collection(db, "caterings"), newEvent);
        this.$router.push(`/muonitus/${docRef.id}`);
      } catch (e) {
        console.error("Error creating event:", e);
        alert("Virhe luotaessa uutta muonitusta: " + e.message);
      }
    },
    openEvent(item) {
      this.$router.push(`/muonitus/${item.id}`);
    },
    onSearchBlur() {
      if (!this.search) {
        this.searchExpanded = false;
      }
    },
  },
};
</script>

<style scoped>
.collapsed-search {
  max-width: 40px;
  transition: max-width 0.3s;
}
.expanded-search {
  max-width: 200px;
  transition: max-width 0.3s;
}
</style>
